import * as signalR from "@microsoft/signalr";
import { SIGNALR_BASE_URL } from "../config/appConfig";

let connection: signalR.HubConnection | null = null;

export const startSignalRConnection = async (
  token: string
) => {
  if (connection) return connection;

  connection = new signalR.HubConnectionBuilder()
    .withUrl(
      `${SIGNALR_BASE_URL}sky999_api_notifications`,
      {
        accessTokenFactory: () => token,
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      }
    )
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();

  try {
    await connection.start();
  } catch (err) {
    console.error("SignalR Connection Error: ", err);
  }

  return connection;
};

export const getSignalRConnection = () => connection;
